import React, { useState } from "react";
import { useApp } from "../context/AppContext";

const NAV = [
  { id: "dashboard", icon: "⊞", label: "Dashboard" },
  { id: "transactions", icon: "⇄", label: "Transactions" },
  { id: "insights", icon: "◈", label: "Insights" },
];

export default function Sidebar({ mobileOpen, onClose }) {
  const { state, dispatch } = useApp();
  const { theme, role, activePage } = state;
  const dark = theme === "dark";

  const colors = {
    sidebar: dark ? "#0d1324" : "#1e293b",
    active: dark ? "rgba(99,102,241,0.2)" : "rgba(99,102,241,0.15)",
    activeBorder: "#6366f1",
    text: dark ? "#cbd5e1" : "#e2e8f0",
    textMuted: dark ? "#475569" : "#94a3b8",
    hover: dark ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.08)",
  };

  return (
    <>
      {/* Mobile overlay */}
      {mobileOpen && (
        <div onClick={onClose} style={{
          position: "fixed", inset: 0, background: 
          "rgba(0,0,0,0.7)", zIndex: 40,
          display: "none",
          "@media (max-width: 768px)": { display: "block" },
        }} className="mobile-overlay" />
      )}

      <aside style={{
        width: 240, minHeight: "100vh", background: colors.sidebar,
        display: "flex", flexDirection:
         "column",
        borderRight: `1px solid ${dark ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.1)"}`,
        flexShrink: 0, position: "relative", zIndex: 41,
        transition: "transform 0.3s ease",
      }} className={`sidebar ${mobileOpen ?
       "mobile-open" : ""}`}>
        {/* Logo */}
        <div style={{ padding: "24px 20px 20px", display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{
            width: 38, height: 38, borderRadius:
             10,
            background: "linear-gradient(135deg, #6366f1, #10b981)",
            display: "flex", alignItems: "center", 
            justifyContent: "center",
            flexShrink: 0, fontSize: 16,
          }}>💹</div>
          <div>
            <div style={{ color: "#fff", 
              fontWeight: 700, fontSize: 15, letterSpacing: "-0.01em" }}>FinanceOS</div>
            <div style={{ color: colors.textMuted, 
              fontSize: 11 }}>Personal Finance</div>
          </div>
        </div>

        <div style={{ height: 1, background: dark ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.1)", margin: "0 16px 16px" }} />

        {/* Nav */}
        <nav style={{ flex: 1, padding: "0 12px" }}>
          <div style={{ color: colors.textMuted,
             fontSize: 10, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", padding: "8px 8px 4px" }}>Navigation</div>
          {NAV.map((item) => {
            const active = activePage === item.id;
            return (
              <button key={item.id} onClick={() => 
                { dispatch({ type: "SET_PAGE", payload: item.id }); onClose?.(); }}
                style={{
                  width: "100%", display: "flex", alignItems: "center", gap: 12,
                  padding: "10px 12px", borderRadius: 10, border: "none", cursor: "pointer",
                  background: active ? colors.active : "transparent",
                  borderLeft: `3px solid ${active ? colors.activeBorder : "transparent"}`,
                  color: active ? "#a5b4fc" : colors.text,
                  fontWeight: active ? 600 : 400, fontSize: 14,
                  marginBottom: 2, transition: "all 0.2s",
                  textAlign: "left",
                }}
                onMouseEnter={(e) => { if (!active) e.currentTarget.style.background = colors.hover; }}
                onMouseLeave={(e) => { if (!active) e.currentTarget.style.background = "transparent"; }}
              >
                <span style={{ fontSize: 18, lineHeight: 1 }}>{item.icon}</span>
                {item.label}
              </button>
            );
          })}
        </nav>

        {/* Role switcher */}
        <div style={{ padding: "16px 16px 12px", borderTop: `1px solid ${dark ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.1)"}` }}>
          <div style={{ color: colors.textMuted, fontSize: 10, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 8 }}>Role</div>
          <div style={{ display: "flex", background: dark ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.1)", borderRadius: 8, padding: 3 }}>
            {["admin", "viewer"].map((r) => (
              <button key={r} onClick={() => dispatch({ type: "SET_ROLE", payload: r })}
                style={{
                  flex: 1, padding: "6px 0", border: "none", cursor: "pointer", borderRadius: 6,
                  background: role === r ? (r === "admin" ? "#6366f1" : "#10b981") : "transparent",
                  color: role === r ? "#fff" : colors.textMuted,
                  fontSize: 12, fontWeight: 600, transition: "all 0.2s",
                  textTransform: "capitalize",
                }}
              >{r}</button>
            ))}
          </div>
          {role === "viewer" && (
            <div style={{ marginTop: 8, padding: "6px 8px", background: "rgba(16,185,129,0.1)", borderRadius: 6, color: "#10b981", fontSize: 11 }}>
              👁 View-only mode
            </div>
          )}
        </div>

        {/* Theme toggle */}
        <div style={{ padding: "12px 16px 20px" }}>
          <button onClick={() => dispatch({ type: "TOGGLE_THEME" })}
            style={{
              width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between",
              padding: "10px 12px", border: `1px solid ${dark ? "rgba(255,255,255,0.08)" : "rgba(255,255,255,0.15)"}`,
              borderRadius: 10, background: "transparent", color: colors.text,
              cursor: "pointer", fontSize: 13, transition: "all 0.2s",
            }}
          >
            <span>{dark ? " Dark Mode" : " Light Mode"}</span>
            <div style={{
              width: 36, height: 20, borderRadius: 10,
              background: dark ? "#6366f1" : "#10b981",
              position: "relative", transition: "background 0.3s",
            }}>
              <div style={{
                position: "absolute", top: 2, width: 16, height: 16, borderRadius: "50%",
                background: "#fff", left: dark ? 18 : 2, transition: "left 0.3s",
              }} />
            </div>
          </button>
        </div>
      </aside>
    </>
  );
}
